class StreetService {
    get_streets(page, data) {
        return axios.post('general/readiness_report_street?page=' + page, data)
    }
    get_street(id) {
        return axios.get('general/readiness_report_street/edit/' + id)
    }
    add_street(data) {
        return axios.post('general/readiness_report_street/store', data)
    }
    edit_street(id, data) {
        return axios.post('general/readiness_report_street/update/' + id, data)
    }
    destroy_street(id) {
        return axios.post('general/readiness_report_street/delete/' + id)
    }
}
export default new StreetService();